import styled from 'styled-components';

export default styled.hr`
  border: none;
  border-top: ${props => `${props.borderWidth+props.borderWidthUnit || '2px'} solid ${props.borderColor}`};
  margin: 2rem 0;  
`;

